/* eslint-disable */
import React from 'react'
import { scaleLinear } from 'd3-scale'
import { line, curveBasis } from 'd3-shape'

import * as d3Color from 'd3-color'
import Color from '../../Utilities/Colors/ColorMap.ts'
import Legend from '../../Legend/Legend.tsx'
import Tooltip from '../../Tooltip/Tooltip.ts'

import setTextColorWithBackground from 'bam-node-baseball-savant/utils/set-text-color-with-background.ts'
import { useTooltip } from '../../Context/ChartContext.tsx'

export default function Scatter({ settings, chartOptions = {} }) {
    const { tooltipRef } = useTooltip()
    const pitchData = settings.data

    const x = scaleLinear().range([0, settings.vizWidth]).domain([-36, 48])
    const y = scaleLinear().range([settings.vizHeight, 0]).domain([96, -12])

    function handleMouseOver(event, tip) {
        Tooltip(event, settings, tooltipRef.current, tip)
    }

    function handleMouseOut(event) {
        Tooltip(event, settings, tooltipRef.current)
    }

    let radiusSize = 3

    if (chartOptions.labelPitches && pitchData.length >= 1000) {
        radiusSize = 10
    } else if (chartOptions.labelPitches && pitchData.length >= 100) {
        radiusSize = 8
    } else if (chartOptions.labelPitches && pitchData.length >= 10) {
        radiusSize = 6
    } else if (chartOptions.labelPitches && pitchData.length >= 1) {
        radiusSize = 5
    }

    const path = line()
        .x((d) => x(d[0]))
        .y((d) => y(d[1]))
        .curve(curveBasis)

    const yLabels = (chartOptions.yLabels || [1, 2, 3, 4, 5, 6, 7]).map(d => 12 * d)
    const xLabels = [-3, -2, -1, 0, 1, 2, 3].map(d => 12 * d)

    return (
        <>
            <g id="movementChart">
                <line
                    x1={x(-36)}
                    x2={x(36)}
                    y1={y(0)}
                    y2={y(0)}
                    stroke="#eeeeee"
                />

                {xLabels.map((label, i) => (
                    <React.Fragment key={`scatter_xLabel_${i}`}>
                        <line
                            key={`xLabelLine_${i}`}
                            x1={x(label)}
                            x2={x(label)}
                            y1={y(0)}
                            y2={y(84)}
                            stroke="#f0f0f0"
                        />
                        <text
                            key={`xLabelText_${i}`}
                            x={x(label)}
                            y={y(-0.12 * 12)}
                            textAnchor="middle"
                            className="release-point-axis-label"
                        >
                            {label != 0 ? `${Math.abs(label)}"` : null}
                        </text>
                    </React.Fragment>
                ))}
                {yLabels.map((label, i) => (
                    <React.Fragment key={`scatter_yLabel_${i}`}>
                        <line
                            key={`yLabelLine_${i}`}
                            x1={x(-36)}
                            x2={x(36)}
                            y1={y(label)}
                            y2={y(label)}
                            stroke="#f0f0f0"
                        />
                        <text
                            key={`yLabelText_${i}`}
                            x={x(-3.6 * 12)}
                            y={y(label + (0.05 * 12))}
                            className="release-point-axis-label"
                        >
                            -{label}"
                        </text>
                    </React.Fragment>
                ))}
                {pitchData.map((d, i) => (
                    <g
                        key={`g_scatter_key_${i}`}
                        transform={`translate(${x(d.x)},${y(d.y)})`}
                        style={{ cursor: 'pointer' }}
                        onMouseOver={(event) => {
                            const html = d.tooltip
                            if (html) {
                                handleMouseOver(event, html)
                            }
                        }}
                        onMouseOut={(event) => {
                            handleMouseOut(event, d)
                        }}
                        onClick={() => {
                            if (d.videoUrl) {
                                window.open(d.videoUrl)
                            }
                        }}
                    >
                        <circle
                            key={`pm_${i}`}
                            r={radiusSize / settings.vizScale}
                            opacity={chartOptions.opacity}
                            fill={Color(
                                chartOptions.legendType,
                                d[chartOptions.legendType]
                            )}
                            stroke="black"
                        />
                        {chartOptions.labelPitches ? (
                            <text
                                className="pitch-label"
                                key={`rp_text_key_${i}`}
                                id={`text_${i}`}
                                textAnchor="middle"
                                dy={4}
                                fill={setTextColorWithBackground(
                                    Color(
                                        chartOptions.legendType,
                                        d[chartOptions.legendType]
                                    )
                                )}
                            >
                                {i + 1}
                            </text>
                        ) : null}
                    </g>
                ))}
            </g>
            {chartOptions.legend ? (
                <Legend settings={settings} type={chartOptions.legendType} />
            ) : null}
        </>
    )
}
